import Media from '@/components/media';
import { Header1, Header3, P1 } from '@bumble/ui-kit';

import styles from './hero.module.scss';

export default function Hero({ data }: { data: any }) {
  const { heroInfo, heroImage, heroImageMobile, title, metIn } = data;
  const imageMobile = heroImageMobile || heroImage;

  return (
    <div className={styles.hero}>
      {heroImage && (
        <div className={styles.image}>
          <Media media={heroImage} fill={true} />
        </div>
      )}

      {imageMobile && (
        <div className={styles.image__mobile}>
          <Media media={imageMobile} fill={true} />
        </div>
      )}

      <div className={styles.content}>
        {title && (
          <div className={styles.title}>
            <Header1 color="brand">{title}</Header1>
          </div>
        )}

        {metIn && (
          <div className={styles.met__in}>
            <Header3 color="brand" as="h2">
              {metIn}
            </Header3>
          </div>
        )}

        {heroInfo && (
          <div className={styles.info}>
            <P1 color="inverse" as="h3">
              {heroInfo}
            </P1>
          </div>
        )}
      </div>

      <div className="gradient" />
    </div>
  );
}
